import { Request } from '../../../httpClient/serverApi/requests/Request';
import { IWorkbookParent } from '../../../workbook/ServerApi/types/IWorkbook';
import { IGetItemsParams } from '../types/IGetItemsParams';
import { IGetItemsResult } from '../types/IGetItemsResult';
import { IRecent } from '../types/IRecent';
import { IViewUsageInfo } from '../types/IUsageInfo';
import { IUser } from '../types/IUser';
import { IView } from '../types/IView';
import { IViewRecommendation } from '../types/IViewRecommendation';
import { INamedItem } from '../types/resourceParts';

export interface IGetRecommendedViewsParams extends IGetItemsParams {
}

export interface IGetRecommendedViewsResult extends IGetItemsResult {
  modelId?: string;
  views?: IView[];
  workbooks?: IWorkbookParent[];
  projects?: INamedItem[];
  users?: IUser[];
  maxStats?: IViewUsageInfo;
  favorites?: string[];
  recents?: IRecent[];
  viewMaxStats?: IViewUsageInfo;
  recommendations?: IViewRecommendation[];
}

export class GetRecommendedViewsRequest extends Request<IGetRecommendedViewsParams, IGetRecommendedViewsResult> {
  constructor(params: IGetRecommendedViewsParams) {
    super('getRecommendations', params);
  }
}
